<template>


  <div class="lms-wrapper-two">

    <student-nav></student-nav>
    <div class="lms-content">
      <student-header class="filled" @toggle-navbar="toggleNavbar($event)" />
      <div
        class="lms-content-body container"
        style="bottom: 0; height: calc(100vh - 80px)"
      >

      <div class="bg-white pd-t-10 pd-x-10 mg-t-10 rounded-20 bd">
      <div class="" v-if="rdy">
        <div ref="refHdr"
          class="d-flex flex-row align-items-center align-items-center justify-content-between"
          v-if="stepCur != 3"
        >
          <ul class="steps mg-b-10">
            <li class="step-item" :class="{ active: stepCur == 1 }">
              <a class="step-link" role="button">
                <span class="step-icon">
                  <feather type="user" class="wd-20-f ht-20-f"></feather>
                </span>
                <div>
                  <span class="step-title">1. Хичээл</span>
                  <span class="step-desc">Хичээл сонгох.</span>
                </div>
              </a>
            </li>
            <li
              class="step-item"
              :class="{ active: stepCur == 2 }"
              v-if="stepHasContract"
            >
              <a class="step-link" role="button">
                <span class="step-icon">
                  <feather type="layers" class="wd-20-f ht-20-f"></feather>
                </span>
                <div>
                  <span class="step-title">2. Гэрээ</span>
                  <span class="step-desc">Гэрээтэй танилцана уу.</span>
                </div>
              </a>
            </li>
            <li
              class="step-item"
              :class="{ active: stepCur == 3 }"
              v-if="stepHasPayment"
            >
              <a class="step-link" role="button">
                <span class="step-icon">
                  <feather type="credit-card" class="wd-20-f ht-20-f"></feather>
                </span>
                <div>
                  <span class="step-title">{{stepHasContract?'3':'2'}}. Төлбөр</span>
                  <span class="step-desc">Төлбөр төлөх.</span>
                </div>
              </a>
            </li>
          </ul>
          <div class>
            <h5
              class="tx-13 text-uppercase"
              style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; max-width: 350px; }"
            >
              {{ course.name }}-нд бүртгүүлэх
            </h5>
          </div>
        </div>
        <section v-if="stepCur == 1">
          <div
            :style="`height: ${scrollHeight}px !important; overflow-y: scroll`"
            class="bg-white pd-x-10"
          >
            <div class="row mg-t-10 tx-color-02">
              <div class="col-sm-6 col-lg-8">
                <label
                  class="tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-02 bd-b"
                  >Багшийн мэдээлэл</label
                >
                <div
                  v-show="teacherIndex == i"
                  v-for="(t, i) in course.teachers"
                  :key="i"
                  class="media"
                >
                  <img
                    :src="`${t.cover}?w=120`"
                    class="wd-120 rounded mg-r-20"
                    alt
                  />
                  <div class="media-body">
                    <h6 class="tx-15 mg-b-10">
                      {{ t.lastName }} {{ t.firstName }}
                    </h6>
                    <p class="mg-b-0">Газар нэгж: {{ t.depart }}</p>
                    <p class="mg-b-0">Албан тушаал: {{ t.position }}</p>
                    <p class="mg-b-0">И мэйл хаяг: {{ t.email }}</p>
                  </div>
                </div>
                <div class="text-center" v-if="course.teachers.length > 1">
                  <feather
                    @click="nextPrevTeacher(-1)"
                    type="chevron-left"
                  ></feather>
                  <feather
                    @click="nextPrevTeacher(1)"
                    type="chevron-right"
                  ></feather>
                </div>
              </div>
              <div class="col-sm-6 col-lg-4">
                <label
                  class="tx-sans tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-02 bd-b"
                  >Сургалтын мэдээлэл</label
                >
                <ul class="list-unstyled lh-7">
                  <li class="d-flex justify-content-between">
                    <span>Эхлэх</span>
                    <span>{{
                      course.date.start | moment("YYYY/MM/DD HH:mm")
                    }}</span>
                  </li>
                  <li class="d-flex justify-content-between">
                    <span>Дуусах</span>
                    <span>{{
                      course.date.end | moment("YYYY/MM/DD HH:mm")
                    }}</span>
                  </li>
                  <li class="d-flex justify-content-between">
                    <span>Төрөл</span>
                    <span>{{ course.locType.name }}</span>
                  </li>
                  <li class="d-flex justify-content-between">
                    <span>Хэлбэр</span>
                    <span>{{ course.locType1.name }}</span>
                  </li>
                </ul>
              </div>
            </div>

            <div class="tx-color-02" v-html="course.info"></div>

            <div class="table-responsive mg-t-40 tx-color-02">
              <table class="table table-invoice bd-b">
                <thead>
                  <tr>
                    <th colspan="3" class>
                      {{
                        course.s2 != null && course.s2 != ""
                          ? course.s2
                          : "Хичээл"
                      }}
                    </th>
                    <th class="tx-center">Цаг</th>
                    <th class="tx-right">Үнэ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colspan="5" class="bg-secondary text-white tx-nowrap">
                      I. Заавал судлах хичээл
                    </td>
                  </tr>
                  <tr
                    v-for="(l, i) in lessons.filter(
                      x => x.locType.code == 'must'
                    )"
                    :key="i"
                  >
                    <td style="width: 50px">{{ i + 1 }}.</td>
                    <td style="width: 50px">
                      <feather type="check-square"></feather>
                    </td>
                    <td class="tx-nowrap wd-80p">{{ l.task }}</td>
                    <td class="tx-center">{{ l.s1 }}</td>
                    <td class="tx-right">{{ l.budget }}</td>
                  </tr>
                  <tr v-show="lessons.filter(x => x.locType.code != 'must').length">
                    <td colspan="5" class="bg-secondary text-white tx-nowrap">
                      II. Хичээл сонгох
                    </td>
                  </tr>
                  <tr
                    v-for="(l, i) in lessons.filter(
                      x => x.locType.code != 'must'
                    )"
                    :key="`${i}_chsn`"
                  >
                    <td>{{ i + 1 }}.</td>
                    <td>
                      <a v-if="l.im != null" role="button">
                        <feather type="square" class="tx-gray-300"></feather>
                      </a>
                      <a v-else @click="l.selcd = !l.selcd" role="button">
                        <feather
                          :type="`${l.selcd ? 'check-square' : 'square'}`"
                        ></feather>
                      </a>
                    </td>
                    <td class="tx-nowrap">
                      <a
                        v-if="l.im != null"
                        role="button"
                        class="tx-gray-500"
                        >{{ l.task }}</a
                      >
                      <a v-else @click="l.selcd = !l.selcd" role="button">{{
                        l.task
                      }}</a>
                    </td>
                    <td class="tx-center">{{ l.s1 }}</td>
                    <td class="tx-right">
                      {{ formatMoney(l.budget, ",", ".") }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="card mg-b-20" v-for="(f,fi) in appForms" :key="fi">
              <div class="card-header d-flex align-items-center justify-content-between">
                <h6 class="mg-b-0">
                  {{ f.nm }}
                </h6>
                <div class="d-flex tx-18">
                  <a v-if="userAgentIOS" :href="`https://link.onoo.mn?l=${f.attachLink}`" target="_blank" 
                    class="btn btn-xs btn-outline-light mg-l-auto"
                  >
                    <feather type="paperclip" class="mg-r-5"></feather>загвар татах 2
                  </a>
                  <a v-else target="_blank"
                    @click="showAttach(f.attachId)"
                    class="btn btn-xs btn-outline-light mg-l-auto"
                  >
                    <feather type="paperclip" class="mg-r-5"></feather>загвар файл татах
                  </a>
                </div>
              </div>

              <div class="pd-10 bg-gray-100 d-flex align-items-center justify-content-center">
                <div v-if="f.attaches.length" class="btn-group">
                  <div @click="showAttachedFile(f.attaches)" class="btn btn-success" >Бөглөсөн файлыг харах</div>
                  <div class="btn btn-warning" @click="showModal(f)">Файлыг ахин илгээх</div>
                </div>
                <div v-else class="btn btn-info" @click="showModal(f)">Бөглөсөн файлыг энд дарж илгээнэ үү</div>
              </div>
            </div>

            <div class="card" v-if="fields.length">
              <div class="card-header bg-primary">
                <h6 class="mg-b-0 tx-white">
                  Бөглөх талбарууд
                </h6>
              </div>
              <div class="card-body">
                <Form inline>
                  <template v-for="(field, i) in fields">
                    <template >
                      <FormItem :label="field.title">
                        <Input v-model="$data['taskFieldsModel'][field.field]" />
                        {{ ['taskFieldsModel'][field.field] }}
                      </FormItem>
                    </template>
                    </template>
                  </Form>
              </div>
            </div>
          </div>
          <div class="row justify-content-between tx-color-02" ref="refFtr">
            <div class="col-sm-6 col-lg-8 order-2 order-sm-0" :class="{'mg-t-10': !$store.state.app.isMobile}">
              <div
                v-if="course.s1 != null && course.s1 != ''"
                class="alert alert-warning mg-b-0 pd-5-f"
                role="alert"
              >
                <h6 class="alert-heading mg-b-0-f">Санамж !</h6>
                <p class="mg-b-0-f">{{ course.s1 }}</p>
              </div>

              <div v-if="stepHasEbarimt">
                <div class="d-flex">
                  <b class="mg-r-10">И-баримт авах хэлбэр</b>
                  <div role="switch" class="el-switch" :class="{'is-checked': ebarimtObj.isorg}" @click="ebarimtObj.isorg=!ebarimtObj.isorg">
                    <span class="el-switch__label el-switch__label--left" :class="{'is-active': !ebarimtObj.isorg}"><!----><span>Иргэн</span></span>
                    <span class="el-switch__core" style="width: 40px;"></span>
                    <span class="el-switch__label el-switch__label--right" :class="{'is-active': ebarimtObj.isorg}"><!----><span aria-hidden="true">ААН</span></span>
                  </div>
                </div>
                <div class="d-flex align-items-center" v-if="ebarimtObj.isorg">
                  <div class="mg-r-10">Регистр № :</div>
                  <div>
                    <input class="form-control" style="height: 25px" v-model="ebarimtObj.regno" />
                  </div>
                  <div class="mg-l-10 badge badge-info" v-show="ebarimtObj.fetched">{{ ebarimtObj.name }}</div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-lg-4 order-1 order-sm-0">
              <ul class="list-unstyled lh-7 pd-r-10 mg-b-5">
                <li class="d-flex justify-content-between" 
                v-if="lessons.filter(x => x.locType.code != 'must').length">
                  <span>Сонгосон хичээлийн төлбөр</span>
                  <span
                    >{{
                      (lessons
                        .filter(l => l.selcd == true)
                        .reduce((sum, l) => sum + l.budget, 0)) | formatMoney(0, ".", ",")
                    }}
                    ₮</span
                  >
                </li>
                <li class="d-flex justify-content-between">
                  <span>Сургалтын төлбөр</span>
                  <span>{{ course.price | formatMoney(0, ".", ",") }} ₮</span>
                </li>
                
                <li class="d-flex justify-content-between" 
                v-if="parseInt(course.too2, 10) > 0">
                  <span>Хямдрал/ Хөнгөлөлт</span>
                  <span v-if="rdy">{{ calculateDiscount() }} ₮</span>
                </li>
                <li class="d-flex justify-content-between">
                  <strong>Төлвөл зохих</strong>
                  <strong v-if="rdy">{{ calculateFinal() }} ₮</strong>
                </li>
              </ul>
              <button
                v-if="stepHasContract || stepHasPayment"
                @click="lessonChoosed()"
                class="btn btn-block btn-primary"
              >
                {{
                  $store.state.app.activeGroup.id == 9241 ||
                  $store.state.app.activeGroup.id == 9249
                    ? "Элсэх"
                    : "Үргэлжлүүлэх"
                }}
              </button>
              <button
                v-else
                @click="joinToCourse()"
                class="btn btn-block btn-primary"
              >
                Элсэх
              </button>
            </div>
          </div>
        </section>
        <section v-else-if="stepCur == 2">
          <div
            class
            :style="
              `height: calc(100vh - ${
                $store.state.app.isMobile ? 400 : 200
              }px);`
            "
          >
            <div class="row no-gutters">
              <div class="col-sm-12 col-lg-8">
                <file-preview
                  v-if="!$store.state.app.isMobile && learnCourseAgreement > 0"
                  :id="learnCourseAgreement"
                  :force="true"
                  :params="{isFull: true}"
                  :minusHeight="$store.state.app.isMobile ? 4000 : ($store.state.app.activeGroup.id == 9157 ? 300 : 200)"
                />
              </div>
              <div class="col-sm-12 col-lg-4">
                <div class="pd-l-10">
                  <template v-if="!hideRequestOption">
                    <div class="form-group row mg-b-0-f">
                      <div class="col-4">
                        <label class="d-block tx-color-03">Сонгоно уу</label>
                      </div>
                      <div class="col-8">
                        <div class="row no-gutters">
                          <Radio v-model="submitModel.i3" label="1" :disabled="$store.state.app.activeGroup.id==9157"
                            >Байгууллага</Radio
                          >
                          <Radio v-model="submitModel.i3" label="2" :disabled="$store.state.app.activeGroup.id==9157"
                            >Хувь хүн</Radio
                          >
                        </div>
                      </div>
                    </div>
                    <div class="form-group row mg-b-0-f">
                      <div class="col-4">
                        <label class="d-block tx-color-03">{{
                          submitModel.i3 == 2 ? "Нэр" : "Байгууллагын нэр"
                        }}</label>
                      </div>
                      <div class="col-8">
                        <input :disabled="$store.state.app.activeGroup.id==9157"
                          v-model="submitModel.task"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="form-group row mg-b-0-f">
                      <div class="col-4">
                        <label class="d-block tx-color-03">{{
                          submitModel.i3 == 2
                            ? "Регистр №"
                            : "Байгууллагын регистр №"
                        }}</label>
                      </div>
                      <div class="col-8">
                        <input v-model="submitModel.st2" class="form-control" :disabled="$store.state.app.activeGroup.id==9157" />
                      </div>
                    </div>
                  </template>

                  <div
                    class="form-group row mg-b-0-f"
                    v-if="$store.state.app.isMobile"
                  >
                    <div class="col-12">
                      <a
                        @click="mdlContract = true"
                        class="btn btn-info btn-block btn-uppercase"
                        role="button"
                        >Энд дарж гэрээтэй танилцана уу !</a
                      >
                    </div>
                  </div>
                  <div class="form-group row mg-b-0-f">
                    <div class="col-4">
                      <label class="d-block tx-color-03"
                        >Гэрээтэй танилцсан</label
                      >
                    </div>
                    <div class="col-8 custom-control custom-checkbox">
                      <a
                        @click="submitModel.isRepeat = !submitModel.isRepeat"
                        role="button"
                      >
                        <feather
                          class="ht-25-f wd-25-f"
                          :type="
                            `${
                              submitModel.isRepeat ? 'check-square' : 'square'
                            }`
                          "
                        ></feather>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="btn-group mg-l-10 wd-100p">
                  <button @click="stepCur--" class="btn btn-warning">
                    Буцах
                  </button>
                  <button @click="submitForm()" class="btn btn-primary">
                    {{$store.state.app.activeGroup.id == 9157?'Сургалтад бүртгүүлэх':'Төлбөр төлөх'}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section v-else-if="stepCur == 3">
          <div class style="height: calc(100vh - 200px);">
            <div class="row no-gutters">
              <div class="col-sm-12">
                <go-payment
                  :invoiceId="invoiceId"
                  @on-pay-success="
                    stepHasPayment = false;
                    modalSuccess = true;
                  "
                >
                  <div class="pd-l-20 pd-t-100 wd-100p btn-group">
                    <button
                      v-if="stepHasContract"
                      @click="stepCur--"
                      class="btn btn-warning"
                    >
                      Сургалтын гэрээ
                    </button>
                    <button class="btn btn-primary">Төлбөр</button>
                  </div>
                </go-payment>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    </div>
    </div>

    <!-- <div class="lms-sidebar">
      <div class="lms-sidebar-body">
        <div class="card">
          <div class="card-body">
            <student-nav />
          </div>
        </div>
      </div>
    </div> -->
    

    <b-modal
      v-model="mdlContract"
      hide-footer
      title="Гэрээ"
      scrollable
      body-class="pd-0-f"
    >
      <file-preview
        v-if="learnCourseAgreement > 0"
        :id="learnCourseAgreement"
        :force="true"
      />
    </b-modal>


    <b-modal
      v-model="modalSuccess"
      hide-footer
      centered
      title="Амжилттай"
      @close="courseDetail()"
      no-close-on-esc
      no-close-on-backdrop
    >
      <div class="mg-x-20">
        <div class="text-center pd-20">
          <h5
            class="text-truncate tx-14-f mg-b-5"
            style="white-space: normal; max-height: 40px; min-height: 40px"
          >
            {{ course.name }} сургалтад амжилттай бүртгүүллээ.
          </h5>
          <div v-if="rdy && checkCourseIsActive() == 0">
            Сургалтын эхлэх хугацаа:
            {{ course.date.start | moment("YYYY.MM.DD HH:mm, dddd") }}
          </div>
          <img src="assets/svg/zoom.svg" />
        </div>
        <div class="text-center">
          <button
            v-if="rdy && checkCourseIsActive() == 1"
            @click="courseDetail()"
            class="btn btn-sm pd-x-15 btn-success btn-uppercase"
          >
            <feather type="check-circle" class="mg-r-5"></feather>
            {{ stepHasPayment ? "Төлбөр төлөх" : "Сургалтыг эхлүүлэх" }}
          </button>
          <router-link
            v-else
            to="/"
            class="btn btn-sm pd-x-15 btn-primary btn-uppercase"
          >
            <feather type="home" class="mg-r-5"></feather>Эхлэл хуудас
          </router-link>
        </div>
      </div>
    </b-modal>

    <file-dialog
      :show="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />

    <b-modal v-model="modal.show" hide-header hide-footer centered>
      <div class="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
        <a
          @click="modal.show = false"
          role="button"
          class="close pos-absolute t-15 r-15"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </a>
        <div class="media align-items-center">
          <span class="tx-color-03 d-none d-sm-block">
            <feather type="pen-tool" class="wd-40-f ht-40-f"></feather>
          </span>
          <div class="media-body mg-sm-l-20">
            <h4 class="tx-18 tx-sm-20 mg-b-2">Файл илгээх</h4>
            <p class="tx-13 tx-color-03 mg-b-0">Загвар файлыг татаж авч бөглөөд илгээнэ үү</p>
          </div>
        </div>
      </div>
      <div class="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
        <div class="form-group">
          <label
            class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03"
            >Тэмдэглэл</label
          >
          <input
            v-model="taskModel.task"
            type="text"
            class="form-control"
            maxlength="450"
            placeholder="Тэмдэглэл бичнэ үү"
          />
        </div>

        <div class="form-group">
          <label
            class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03"
            >Файл</label
          >
          <simple-uploader
            v-model="taskModel.defaultAttachmentId"
            :propObjectTypeId="6"
            @on-success="fileUploaded"
          >
            <div slot="trigger">
              <div
                v-if="taskModel.defaultAttachmentId == null"
                class="btn btn-primary"
                style="height: 38px"
              >
                <label style="margin-btoom: 0" class="custom-file-label"
                  >Файл сонгоогүй байна</label
                >
              </div>
              <div
                v-else
                class="btn d-flex align-items-center btn-outline-success btn-block btn-xs"
                style="height: 38px"
                @click.prevent.stop="taskModel.defaultAttachmentId = null"
              >
                <span class="mg-l-auto d-flex align-items-center text-danger">
                  Болих
                  <feather type="x" class="mg-l-5"></feather>
                </span>
              </div>
            </div>
          </simple-uploader>
        </div>
      </div>
      <div class="modal-footer pd-x-20 pd-y-15">
        <button
          @click="modal.show = false"
          type="button"
          class="btn btn-white"
          data-dismiss="modal"
        >
          Болих
        </button>
        <button @click="postTask" type="button" class="btn btn-primary">
          Файл илгээх
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
const moment = require("moment");
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { request } from "@/api/all";
import { formatMoney } from "@/libs/tools";

import "element-ui/lib/theme-chalk/index.css";
import { Form, FormItem, Input, Radio, Checkbox, Notification } from "element-ui";

import { filePreviewDetail } from "@/api/media";
import { getInheritedTask, postInheritedTask } from "@/api/task";

export default {
  components: {
    Form, FormItem, Input,
    Radio,
    Checkbox,
    vueCustomScrollbar,
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    filePreview: () => ({
      component: import("@/components/modules/media/previewPage.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    goPayment: () => ({
      component: import("@/components/modules/payment"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      ebarimtObj:{
        isorg: false,
        regno: null,
        fetched: false,
        name: null,
        id: null,
      },
      fields: [],
      taskFieldsModel: {},
      userAgentIOS: false,
      scrollHeight: 0,
      projId: null,
      taskModel: {},
      modal: {
        show: false
      },



      fileDialog: {
        show: false,
        id: 0
      },

      mdlContract: false,
      course: {},
      lessons: [],
      appForms: [],
      rdy: false,
      modalSuccess: false,
      stepCur: 1,

      submitModel: {
        task: ""
      },
      profileModel: {},

      stepHasContract: false,
      stepHasPayment: false,
      stepHasEbarimt: false,
      invoiceId: null,
      filePreview: {
        show: true,
        id: 472288
      },
      teacherIndex: 0,
      learnCourseAgreement: 0,
      hideRequestOption: false
    };
  },
  mounted() {
    //console.log('attendee page fired');
    // this.toggleBodyClass("addClass", "app-lms");
    // require('@/assets/scss/pages/course.scss');
    // require("@/assets/css/dynamic.lms.css");
    this.init();
    this.configure();
    
    window.addEventListener("resize", this.getScrollHeight);

    this.userAgent = window.navigator.userAgent;
    //console.log("userAgent", this.userAgent);
    if (this.userAgent.match(/iPad/i) || this.userAgent.match(/iPhone/i)) {
      this.userAgentIOS = true;
    }
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.getScrollHeight);
  },
  destroyed() {
    // this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    nextPrevTeacher(m) {
      if (m == 1)
        if (this.teacherIndex < this.course.teachers.length - 1) {
          this.teacherIndex++;
        } else {
          this.teacherIndex = 0;
        }
      else if (m == -1)
        if (this.teacherIndex > 0) {
          this.teacherIndex--;
        } else if (this.teacherIndex == 0) {
          this.teacherIndex = this.course.teachers.length - 1;
        } else {
          this.teacherIndex = 0;
        }
    },
    configure() {
      let _geree = this.$store.state.app.groupSettings.filter(
        x => x.key == "lmsAttendHasContract"
      );
      if (
        _geree.length > 0 &&
        _geree[0].value != undefined &&
        _geree[0].value == "1"
      ) {
        this.stepHasContract = true;
      }

      let _pay = this.$store.state.app.groupSettings.filter(
        x => x.key == "lmsAttendHasPayment"
      );
      if (
        _pay.length > 0 &&
        _pay[0].value != undefined &&
        _pay[0].value == "1"
      ) {
        this.stepHasPayment = true;
      }

      let _ebrmt = this.$store.state.app.groupSettings.filter(
        x => x.key == "paymentEbarimt"
      );
      if (
        _ebrmt.length > 0 &&
        _ebrmt[0].value != undefined &&
        _ebrmt[0].value == "1"
      ) {
        this.stepHasEbarimt = true;
      }

      

      let _learnCourseAgreement = this.$store.state.app.groupSettings.filter(
        x => x.key == "learnCourseAgreement"
      );
      if (
        _learnCourseAgreement.length > 0 &&
        _learnCourseAgreement[0].value != undefined
      ) {
        this.learnCourseAgreement = _learnCourseAgreement[0].value;
      }

      let hdetmp = this.$store.state.app.groupSettings.filter(
        x => x.key == "learnCourseDisableRequestOption"
      );
      if (hdetmp != undefined) {
        if (hdetmp == 1) {
          this.hideRequestOption = true;
        } else {
          this.hideRequestOption = false;
        }
      }
    },
    init() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "V2/Learn/courseDetail" },
        params: { id: this.$route.params.id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        //console.log('courseDetail=> ', res.data.course.boxes.filter(x => x.ot == 530));
        if (res != false) {
          if (res.data.course.boxes.filter(x => x.ot == 114).length) {
            //console.log(res.data.course.boxes.filter(x=>x.ot==114)[0]);
            this.lessons = res.data.course.boxes.filter(
              x => x.ot == 114
            )[0].tasks;
            this.lessons.forEach(t => {
              t.selcd = t.locType.code == "must";
            });
            //console.log(this.lessons);
          }

          this.appForms= res.data.course.boxes.filter(x => x.ot == 530);
          
          this.course = res.data.course;
          this.rdy = true;

          this.initAfter();

          if(this.course.isRepeat){
            this.initFields();
          }
        }
      });
    },
    initFields(){
      //TaskCore/GetEditRequireFromOtherFields
      request({
        api: { method: "GET", url: "TaskCore/GetEditRequireFromOtherFields" },
        params: {
          objectTypeId: 138
        },
        store: this.$store
      }).then(res => {
        //console.log('res', res);
        this.fields = res.data.fields;

        let _pid = 0;
        let prj = this.$store.state.app.groupDefaultProjects.filter(
          (x) => x.objectTypeId == parseInt(138, 10)
        );
        if (prj.length > 0) _pid = prj[0].id;
        //console.log('get inherited', _pid, this.$store.state.user.userInfo.profileId);
        let _uid = 0;
        if (this.manager) {
          _uid = this.propId;
        } else {
          if (this.id > 0) {
            _uid = this.id;
          } else {
            _uid = this.$store.state.user.userInfo.profileId;
          }
        }
        getInheritedTask({
          params: {
            id: _uid,
            objectTypeId: 138,
            parentId: 0,
            projectId: _pid,
            boxId: 0,
            userId: this.$store.state.user.userInfo.userId,
          },
          store: this.$store
        }).then(res => {
          this.taskFieldsModel = res.data.task;
        });
      });
    },
    initAfter() {
      request({
        api: { method: "GET", url: "task/taskInheritedDetail" },
        params: {
          id: this.$route.params.id,
          requestFlag: 293
        },
        store: this.$store
      }).then(res => {
        //console.log('task/taskInheritedDetail=> ', res)
        if (res != false) {
          let invoiceBoxId = 0;
          if (res.data.task.b.filter(x => x.ot == 343).length > 0) {
            invoiceBoxId = res.data.task.b.filter(x => x.ot == 343)[0].id;
          }

          let _projid = 0;
          let prj = this.$store.state.app.groupDefaultProjects.filter(
            x => x.objectTypeId == 343
          );
          if (prj.length > 0) _projid = prj[0].id;

          request({
            api: { method: "GET", url: "Task/GetInherited" },
            params: {
              id: 0,
              projectId: _projid,
              parentId: 0,
              boxId: invoiceBoxId,
              objectTypeId: 343,
              userId: this.$store.state.user.userId,
              force: true, //this.forceJoin
              lmsV2: true
            },
            store: this.$store
          }).then(res => {
            //console.log('Task/GetInherited=> ', res);
            if (res != false) {
              if (res.hasInvoice != undefined && res.hasInvoice == true) {
                Notification.info({
                  message:
                    "Та хүсэлт илгээсэн байна. Дараах нэхэмжлэхийг төлснөөр таны хүсэлт баталгаажна.",
                  duration: 5000,
                  type: "info",
                  position: "top-right",
                  offset: 50
                });
                this.$router.push("/lms/paymentDetail/" + res.invoiceId);
              } else {
                this.submitModel = res.data.task;

                this.getScrollHeight();
              }
            } else {
              this.$router.push("/lms/participant");
            }
          });
        }
      });
    },
    createOrGetOrgIdByRegNo(){
      let errs = [];

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "CRM/CreateOrGetOrgIdByRegNo" },
        data: {regNo: this.ebarimtObj.regno},
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          // console.log('res', res.data)
          this.ebarimtObj.name= res.data.name;
          this.ebarimtObj.id= res.data.id;
          this.ebarimtObj.fetched= true;

          this.submitModel.i3= "1"; 
          this.submitModel.task= this.ebarimtObj.name; 
          this.submitModel.st2= this.ebarimtObj.regno;
          Notification.info({
            message: `${res.data.name} байгууллагын мэдээллийг амжилттай татлаа дараах дарж үргэлжлүүлнэ үү`,
            duration: 3000,
            type: "info",
            position: "top-right",
            offset: 50
          });
          this.lessonChoosed();
        }else{
          this.ebarimtObj.fetched= false;
        }
        // else{
        //   Notification.warning({
        //     message: 'Байгууллагын регистр оруулна уу !',
        //     duration: 3000,
        //     type: "info",
        //     position: "top-right",
        //     offset: 50
        //   });
        // }
      });
    },
    lessonChoosed() {
      let lidsSend = this.lessons
        .filter(l => l.selcd == true)
        .map(function(e) {
          return e.id;
        });

      let AlllidsSend = this.lessons.map(function(e) {
        return e.id;
      });

      let errs = [];

      if (
        AlllidsSend.length > 0 &&
        lidsSend.length <= 0 &&
        this.stepHasPayment
      ) {
        errs.push("Хичээл сонгоогүй байна !");
      }

      if(this.$store.state.app.activeGroup.id == 9265 || this.$store.state.app.activeGroup.id == 9311){
        if(this.appForms.filter(x=>x.objectTypeId>0).length>0){
          errs.push(this.appForms.filter(x=>x.objectTypeId>0)[0]['nm']+" файл бөглөж илгээгээгүй байна !");
        }
      }

      if(this.$store.state.app.activeGroup.id == 9157){
        if(this.ebarimtObj.isorg && !this.ebarimtObj.fetched){
          this.createOrGetOrgIdByRegNo();
          return;
        } else if(!this.ebarimtObj.isorg){
          this.submitModel.i3= "2";
          // console.log(this.$store.state.user.userInfo);
          this.submitModel.task= this.$store.state.user.userInfo.fullName; 
          this.submitModel.st2= this.$store.state.user.userInfo.register;
        }
      }

      if (this.$store.state.app.activeGroup.id == 6126) {
        //console.log('step 1');
        if (
          this.lessons.filter(
            l =>
              l.locType != undefined &&
              l.locType != null &&
              l.locType.code == "chosen"
          ).length > 0 &&
          this.lessons.filter(
            l =>
              l.locType != undefined &&
              l.locType != null &&
              l.locType.code == "chosen"
          ).length < 5
        ) {
          //console.log('step 2');
          if (lidsSend.length == 0 && this.stepHasPayment) {
            //console.log('step 3');
            errs.push("Хичээл сонгоогүй байна !");
          }
        } else if (
          this.lessons.filter(
            l =>
              l.locType != undefined &&
              l.locType != null &&
              l.locType.code == "chosen"
          ).length >= 5
        ) {
          //console.log('step 4', lidsSend.length, this.stepHasPayment, lidsSend.length < 2);
          let chosenLids = this.lessons
            .filter(l => l.selcd == true && l.locType.code == "chosen")
            .map(function(e) {
              return e.id;
            });
          if (chosenLids.length < 2 && this.stepHasPayment) {
            //console.log('step 5');
            errs.push(
              "Та тасралтгүй боловсрол олгох хичээлээс 2-оос доошгүй кредит цагийн хичээл судалсан байна !"
            );
          }
        }
        //console.log(this.lessons.filter(l => l.locType!=undefined && l.locType!=null && l.locType.code == "chosen").length);
      }

      if(this.fields.length){
        let _flds= [];
        this.fields.forEach(e=>{
          //if(e.rule.required){
            if(this.taskFieldsModel[e.field]==null || this.taskFieldsModel[e.field]==''){
              errs.push(e.title+' бөглөнө үү');
              _flds.push(e.title);
            }
            // isValid = this.taskModel[e.field]!=null;
            // if(this.taskModel[e.field]=="")
            //   isValid = false;
            // if(!isValid)
            // {
            //   isValid=false;
            // }
          //}
        })

        if(_flds.length<=0){
          postInheritedTask({
            data: { model: this.taskFieldsModel },
            store: this.$store
          });
        }
      }

      if (errs.length > 0) {
        Notification.warning({
          message: errs[0],
          duration: 3000,
          type: "info",
          position: "top-right",
          offset: 50
        });
      } else {
        //console.log('this.course.invoice', this.course.invoice);
        if (!this.stepHasContract) {
          //this.stepCur = 2; //#huuchin iim bsan 2021.08.17 zasav
          this.joinToCourse(true); //# step 2 deer bichdeg hesgiig aut fill hiihiin tuld force true yavuulav
        } else {
          //this.submitModel.task = this.$store.state.user.userInfo.fullName;
          this.stepCur++;
        }
      }
    },
    joinToCourse(force) {
      // console.log('joinToCourse fired');
      // console.log(this.course.invoice);
      if (this.course.invoice != null) {
        if (this.course.invoice.isPayed) {
          this.$router.push({
            name: "lmsCourseView",
            params: {
              id: this.$route.params.id,
              bid: 0,
              iid: 0,
              bot: 0
            }
          });
        } else {
          this.invoiceId = this.course.invoice.id;
          this.modalSuccess = true;
        }
      } else {
        let lidsSend = this.lessons
          .filter(l => l.selcd == true)
          .map(function(e) {
            return e.id;
          });

        let connectTaskToBox = [];
        let pppp = {
          boxObjectTypeId: 114,
          taskIds: lidsSend,
          name: "Сонгосон хичээлүүд"
        };

        connectTaskToBox.push(pppp);
        this.submitModel.connectTaskToBox = connectTaskToBox;

        let errs = [];

        if (force != undefined && force) {
          this.submitModel.i3 = 2;
          this.submitModel.task = this.$store.state.user.userInfo.fullName;
          this.submitModel.st2 = this.$store.state.user.userInfo.register;
          this.submitModel.isRepeat = true;
        }

        if (this.submitModel.i3 <= 0 && this.stepHasPayment) {
          errs.push("Байгууллага эсвэл хувь хүн сонгоно уу !");
        }
        //console.log(this.submitModel);
        if (
          (this.submitModel.task == undefined || this.submitModel.task == "") &&
          this.stepHasPayment
        ) {
          errs.push("Нэр бичнэ үү !");
        }

        if (!this.submitModel.isRepeat && this.stepHasPayment) {
          errs.push("Гэрээг зөвшөөрөөгүй байна !");
        }

        if(this.ebarimtObj.isorg){
          if(this.ebarimtObj.regno!=null && this.ebarimtObj.regno!=''){
            this.submitModel.i3= 1;
            this.submitModel.st2= this.ebarimtObj.regno;
          }else{
            errs.push("Байгууллага регистр бичнэ үү!");
          }
          
        }

        if (errs.length > 0) {
          Notification.warning({
            message: errs[0],
            duration: 3000,
            type: "info",
            position: "top-right",
            offset: 50
          });
        } else {
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "GET", url: "Task/GetInherited" },
            params: { id: this.$store.state.user.userInfo.profileId },
            store: this.$store
          }).then(res => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              //console.log('Task/GetInherited=> ', res);

              this.profileModel = res.data.task;

              //console.log("before", this.submitModel.task);
              //# 2021.10.14 commentlov elsehdee bichsen baiguullagiin neriig daraad bsan
              //this.submitModel.task = this.$store.state.user.userInfo.fullName;
              // gereegui uyed ajilbariin neriig zaaval oruulged bga uchir ene nuhtsliig nemev 2021-11-03

              if (!this.stepHasContract)
                this.submitModel.task = this.$store.state.user.userInfo.fullName;
              //console.log("after", this.submitModel.task);

              this.submitModel.taskDesc = `${this.course.name}-н төлбөр. Овог ${this.profileModel.lat} Нэр: ${this.profileModel.task} Регистр: ${this.profileModel.langCode}`;
              this.submitModel.thirdOrganizationTaskId = this.$route.params.id;
              lidsSend.push(this.$route.params.id);

              this.submitModel.parentId = 0;

              this.toggleBodyClass("addClass", "dynamic-locker");
              request({
                api: { method: "POST", url: "Task/PostInherited" },
                data: { model: this.submitModel },
                store: this.$store
              }).then(res => {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                if (res != false) {
                  this.invoiceId = res.taskId;
                  //console.log('Task/PostInherited=> ', res);
                  this.toggleBodyClass("addClass", "dynamic-locker");
                  request({
                    api: {
                      method: "POST",
                      url: "Payment/PostProductAndWorkservice"
                    },
                    data: { invoiceId: res.taskId, workIds: lidsSend },
                    store: this.$store
                  }).then(res => {
                    this.toggleBodyClass("removeClass", "dynamic-locker");
                    if (res != false) {
                      //this.rdy= false;
                      if (!this.stepHasPayment) {
                        this.modalSuccess = true;
                      } else if (!this.stepHasContract) {
                        this.stepCur = 3;
                      } else {
                        this.stepCur++;
                      }
                      //console.log('Payment/PostProductAndWorkservice=> ', res);
                    }
                  });
                }
              });
            }
          });
        }
      }
    },
    showModal(frm){
      //console.log('frm', frm);
      let _ot = this.$store.state.app.groupDefaultProjects.filter(
        x => x.objectTypeId == frm.ot
      );
      if (_ot.length) {
        this.projId = _ot[0].id;
      }

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Task/GetInherited" },
        params: {
          id: 0,
          boxId: frm.id,
          parentId: this.$route.params.id,
          objectTypeId: frm.ot,
          projectId: this.projId
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.taskModel = res.data.task;
          this.modal.show = true;
        }
      });
    },
    showAttach(id){
      //console.log('id', id);
      // this.fileDialog.id = parseInt(id, 10);
      // this.fileDialog.show = true;
      filePreviewDetail({ params: { id: id }, store: this.$store }).then(res => {
        if (res != false) {
          let _url=res.data.file.link+ "?i=" + Math.floor(Math.random() * 100);
          //window.open( "https://link.onoo.mn?l="+_url , "_blank");

          var encoded = encodeURIComponent(_url);
          window.open(`https://link.onoo.mn?l=${encoded}`, this.userAgentIOS?"":"_blank");
        }
      });
     
    },
    courseDetail() {
      //console.log("courseDetail=> ", this.stepHasContract, this.stepHasPayment);
      //if(!this.stepHasContract && this.stepHasPayment){
      if (this.stepHasPayment && this.stepCur != 3) {
        //this.invoiceId
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "payment/createPDFInvoice" },
          data: { invoiceId: this.invoiceId },
          store: this.$store
        }).then(res => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          //console.log("createPDFInvoice", res);
          if (res != false) {
            this.rdy = true;
            this.modalSuccess = false;
            this.stepCur = 3;

            this.filePreview.id = parseInt(res.data.file.id, 10);
            this.filePreview.show = true;
          }
        });
      }
      // else if(this.stepHasContract){
      //     this.stepCur= 2;
      //     this.modalSuccess=false;
      // }
      else {
        ///console.log(this.course);
       
        
        if(this.lessons.length>0){
          this.$router.push({
            name: "lmsLessonView",
            params: {
              id: this.lessons[0]['id'],
              cid: this.$route.params.id,
              bid: 0,
              iid: 0,
              bot: 0
            }
          });
        }else{
           this.$router.push({
            name: "lmsCourseView",
            params: {
              id: this.$route.params.id,
              bid: 0,
              iid: 0,
              bot: 0
            }
          });
        }
        
      }
    },
    checkCourseIsActive() {
      if (moment(this.course.date.end).isBefore(moment(this.course.date.now))) {
        //# duussan
        return -1;
      } else if (
        moment(this.course.date.start).isBefore(moment(this.course.date.now)) &&
        moment(this.course.date.end).isAfter(moment(this.course.date.now))
      ) {
        //# urgeljilj bgaa
        return 1;
      } else if (
        moment(this.course.date.start).isAfter(moment(this.course.date.now))
      ) {
        //# ehleegui
        return 0;
      }
    },
    calculateDiscount() {
      if (
        this.lessons.filter(l => l.selcd == true).length == this.course.too2 &&
        this.course.too2 > 0
      ) {
        let hasah =
          ((this.course.budget +
            this.lessons
              .filter(l => l.selcd == true)
              .reduce((sum, l) => sum + l.budget, 0)) *
            this.course.too1) /
          100;
        //console.log('hasah', this.course.budget);
        return formatMoney(hasah, ",", ".");
      } else {
        return "0";
      }
    },
    calculateFinal() {
      let niit =
        this.course.budget +
        this.lessons
          .filter(l => l.selcd == true)
          .reduce((sum, l) => sum + l.budget, 0);
      //&& !this.forceJoin
      if (
        this.lessons.filter(l => l.selcd == true).length == this.course.too2 &&
        this.course.too2 > 0
      ) {
        let hasah =
          ((this.course.budget +
            this.lessons
              .filter(l => l.selcd == true)
              .reduce((sum, l) => sum + l.budget, 0)) *
            this.course.too1) /
          100;
        return formatMoney(niit - hasah, ",", ".");
      } else {
        return formatMoney(niit, ",", ".");
      }
    },
    formatMoney(n, c, d, t) {
      return formatMoney(n, c, d, t);
    },

    submitForm() {
      this.joinToCourse();
      //this.stepCur++;
    },

    fileUploaded(e) {
      this.taskModel.defaultAttachmentId = e.uploadedAttachmentId;
    },
    showAttachedFile(e){
      this.fileDialog.id = e[0];
      this.fileDialog.show = true;
    },
    postTask() {
      if(this.taskModel.defaultAttachmentId<=0){
        Notification.info({ message: "Файл сонгоно уу.", duration: 5000, type: "warning", position: "top-right", offset: 50 });
      }else{
        if(this.taskModel.task=='' || this.taskModel.task==undefined || this.taskModel.task==null){
          this.taskModel.task= "Файл";
        }

        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "Task/PostInherited" },
          data: {
            model: this.taskModel
          },
          store: this.$store
        }).then(res => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            if(this.appForms.filter(x=>x.id==this.taskModel.boxId).length){
              this.appForms.filter(x=>x.id==this.taskModel.boxId)[0]['objectTypeId']=-11;
              this.appForms.filter(x=>x.id==this.taskModel.boxId)[0]['attaches'].push(this.taskModel.defaultAttachmentId);
            }
            this.modal.show = false;
          }
        });
      }
      
    },

    getScrollHeight() {
      let mh = 150;
      if(this.stepCur!=3 && this.rdy){
        mh = mh + this.$refs.refHdr.clientHeight;
      }

      //if (this.$store.state.app.isMobile) {
        mh = mh + this.$refs.refFtr.clientHeight;
      //}
      
      this.scrollHeight = window.innerHeight - mh;
    },
  }
};
</script>

<style></style>
